import { render } from "./JurySelection.vue?vue&type=template&id=6f126a39&scoped=true"
import script from "./JurySelection.vue?vue&type=script&lang=js"
export * from "./JurySelection.vue?vue&type=script&lang=js"

import "./JurySelection.vue?vue&type=style&index=0&id=6f126a39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f126a39"]])

export default __exports__